<div class="main">
  <h2>Ensayos en ICP</h2>

  <div style="min-height: 50vh; width: 100vw" *ngIf="isLoading">
    <div class="loading-shade">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div *ngIf="!isLoading">
    <table mat-table [dataSource]="wellTests" class="well-tests">
      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef> Fecha Int </mat-header-cell>
        <mat-cell *matCellDef="let wt">
          {{ wt.startDate | date : "dd/MM/yyyy" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="top">
        <mat-header-cell *matHeaderCellDef> Tope [m] </mat-header-cell>
        <mat-cell *matCellDef="let wt">
          {{ wt.top | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="base">
        <mat-header-cell *matHeaderCellDef> Base [m] </mat-header-cell>
        <mat-cell *matCellDef="let wt">
          {{ wt.base | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="symbol">
        <mat-header-cell *matHeaderCellDef> Resultado </mat-header-cell>
        <mat-cell *matCellDef="let wt">
          {{ wt.symbol }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="qp">
        <mat-header-cell *matHeaderCellDef> QO </mat-header-cell>
        <mat-cell *matCellDef="let wt">
          {{ wt.qp | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="qg">
        <mat-header-cell *matHeaderCellDef> QG </mat-header-cell>
        <mat-cell *matCellDef="let wt">
          {{ wt.qg | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="qa">
        <mat-header-cell *matHeaderCellDef> QW </mat-header-cell>
        <mat-cell *matCellDef="let wt">
          {{ wt.qa | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="gross">
        <mat-header-cell *matHeaderCellDef> Bruta </mat-header-cell>
        <mat-cell *matCellDef="let wt">
          {{ wt.gross | number : "1.2-2" }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="level">
        <mat-header-cell *matHeaderCellDef> Nivel </mat-header-cell>
        <mat-cell *matCellDef="let wt">
          {{ wt.level | number : "1.2-2" }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="noData">
        <mat-footer-cell *matFooterCellDef colspan="4">
          <div class="footer">
            <div class="footer-no-data">No se encontraron datos.</div>
            <div class="footer-no-data-origin">
              De existir datos en el sistema de origen, podrás visualizarlos
              acá.
            </div>
          </div>
        </mat-footer-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      <mat-footer-row
        *matFooterRowDef="['noData']"
        [ngClass]="{ 'hide-footer': hideFooter }"
      ></mat-footer-row>
    </table>
  </div>
</div>
